import { catchError } from 'rxjs/operators';
import { PjeResponse } from './../../model/pje-response.model';
import { Injectable } from "@angular/core";
import { GenericService } from "app/core/services";
import { AppConfig } from '../../app.config';
import { REQUISITORIO } from "app/core/services/rest-servers";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ParametroRequisitorio } from "app/requisitorio/model/parametro-requisitorio.model";

@Injectable()
export class ParametroRequisitorioService extends GenericService<any> {

  private urlPrefix: string = this.config.getUrlServidorRequisitorio() + '/api/v1/requisitorios/parametros';
  // private urlPrefix: string = this.config.getUrlApiGateway() + REQUISITORIO + '/v1/requisitorios/parametros';

  constructor(private http: HttpClient, private config: AppConfig) {
    super(http,  config);
  }

  public salvarParametro(parametroRequisitorio: ParametroRequisitorio): Observable<PjeResponse<ParametroRequisitorio>> {
    return this.http.put<PjeResponse<any>>(this.urlPrefix + '/edit/' + parametroRequisitorio.id, parametroRequisitorio).pipe(catchError(this._serverError));
  }

  public buscarParametro(nomeDaVariavel: string): Observable<PjeResponse<ParametroRequisitorio>> {
    return this.http.get<PjeResponse<ParametroRequisitorio>>(this.urlPrefix + '/' + nomeDaVariavel).pipe(catchError(this._serverError));
  }

  public salvarParametros(listaParametros: ParametroRequisitorio[]): Observable<PjeResponse<ParametroRequisitorio[]>> {
    return this.http.put<PjeResponse<ParametroRequisitorio[]>>(this.urlPrefix + '/edit-all' , listaParametros).pipe(catchError(this._serverError));
  }

  public findAllByListaNomeVariavel(listaParametros: string[]): Observable<PjeResponse<ParametroRequisitorio[]>> {
    return this.http.post<PjeResponse<ParametroRequisitorio[]>>(this.urlPrefix + '/findAllParametrosByLista', listaParametros).pipe(catchError(this._serverError));
  }

  public exibirCampoIncapaz(): Observable<PjeResponse<boolean>> {
    return this.http.get<PjeResponse<boolean>>(this.urlPrefix + '/exibir-campo-incapaz').pipe(catchError(this._serverError));
  }

  public exibirCampoValorCompensar(): Observable<PjeResponse<boolean>> {
    return this.http.get<PjeResponse<boolean>>(this.urlPrefix + '/exibir-campo-valor-compensar').pipe(catchError(this._serverError));
  }

  public exibirCampoIsencaoIr(): Observable<PjeResponse<boolean>> {
    return this.http.get<PjeResponse<boolean>>(this.urlPrefix + '/exibir-campo-isencao-ir').pipe(catchError(this._serverError));
  }
}
